import React, { useMemo } from "react";
import CodeMirror from "@uiw/react-codemirror";
import { EditorView } from "@codemirror/view";

import { python } from "@codemirror/lang-python";
import { javaLanguage } from "@codemirror/lang-java";
import { cppLanguage } from "@codemirror/lang-cpp";
import { javascript } from "@codemirror/lang-javascript";
import { html } from "@codemirror/lang-html";
import { css } from "@codemirror/lang-css";
import { sql } from "@codemirror/lang-sql";
import { json } from "@codemirror/lang-json";
import { markdown } from "@codemirror/lang-markdown";

export default function CodeEditor({
                                       value,
                                       onChange,
                                       language = "python",
                                       readOnly = false,
                                       height = 280,
                                   }) {

    const extensions = useMemo(() => {

        const lang = String(language).toLowerCase();

        switch (lang) {

            case "python":
            case "py":
                return [python()];

            case "java":
                return [javaLanguage];

            case "cpp":
            case "c++":
            case "c":
                return [cppLanguage];

            case "javascript":
            case "js":
                return [javascript()];

            case "html":
                return [html()];

            case "css":
                return [css()];

            case "sql":
                return [sql()];

            case "json":
                return [json()];

            case "markdown":
            case "md":
                return [markdown()];

            default:
                return [];
        }

    }, [language]);

    return (

        <div className="rounded-xl border overflow-hidden ltr bg-white">

            <div className="px-3 py-2 border-b bg-gray-50 flex justify-between">

                <span
                    className="font-mono text-xs text-gray-600"
                    dir="ltr"
                >
                    {language}
                </span>

                {
                    readOnly &&
                    <span className="text-xs text-gray-500">
                        Read Only
                    </span>
                }

            </div>

            <CodeMirror
                value={value || ""}
                height={`${height}px`}
                editable={!readOnly}
                extensions={[
                    ...extensions,
                    EditorView.lineWrapping
                ]}
                basicSetup={{
                    foldGutter: true,
                    highlightActiveLine: true,
                    lineNumbers: true,
                    autocompletion: false,
                }}
                onChange={onChange}
            />

        </div>

    );

}